import React, { memo } from 'react'

import { SIGNUP_PROFILE_DISPATCH } from '../../store/reducers/auth/signup'
import LoginLinkText from '../shared/loginLinkText/LoginLinkText'
import customConfig from 'customConfig'
import SocialMedia from '../socialMedia/SocialMedia'
import { LOG_IN_URL } from '../../constants/navigation'
import { FormHead } from '../../auth/components/form-head'
import { FormDivider } from '../../auth/components/form-divider'
import CustomForm from '../shared/inputs/CustomForm'
import SubmitButton from '../shared/button/SubmitButton'
import CustomTextField from '../shared/inputs/CustomTextField'
import { Box } from '@mui/material'

const SignupForm = ({
  onFormSubmit,
  dispatchAction,
  signupProfile: { error, firstName, lastName, email, password, isProcessing },
  onSocialMediaLogin,
  t
}) => {
  const errorEmail = t(error[SIGNUP_PROFILE_DISPATCH.EMAIL])
  return (
    <>
      <FormHead
        title={t('sign-up.start-earning-your-points')}
        sx={{ textAlign: { xs: 'center', md: 'left' } }}
      />
      <SocialMedia onSocialMediaLogin={onSocialMediaLogin} />
      <FormDivider label={t('common.or')} />
      <CustomForm onFormSubmit={onFormSubmit}>
        <Box sx={{ gap: 3, display: 'flex', flexDirection: 'column' }}>
          <CustomTextField
            label={t('common.first-name')}
            error={t(error[SIGNUP_PROFILE_DISPATCH.FIRST_NAME])}
            value={firstName}
            onChange={(value) =>
              dispatchAction(SIGNUP_PROFILE_DISPATCH.FIRST_NAME, value)
            }
          />
          <CustomTextField
            label={t('common.last-name')}
            error={t(error[SIGNUP_PROFILE_DISPATCH.LAST_NAME])}
            value={lastName}
            onChange={(value) =>
              dispatchAction(SIGNUP_PROFILE_DISPATCH.LAST_NAME, value)
            }
          />
          <CustomTextField
            type='email'
            label={t('common.email-address')}
            error={errorEmail}
            value={email}
            onChange={(value) =>
              dispatchAction(SIGNUP_PROFILE_DISPATCH.EMAIL, value)
            }
          />
          <CustomTextField
            label={t('common.password')}
            eyePassword
            error={t(error[SIGNUP_PROFILE_DISPATCH.PASSWORD])}
            value={password}
            onChange={(value) =>
              dispatchAction(SIGNUP_PROFILE_DISPATCH.PASSWORD, value)
            }
          />
          <SubmitButton
            label={t(customConfig.signupButtonLabel)}
            loading={isProcessing}
          />
          <LoginLinkText
            label={t('common.already-have-an-account')}
            actionLabel={t('login.log-in')}
            to={LOG_IN_URL}
          />
        </Box>
      </CustomForm>
    </>
  )
}

export default memo(SignupForm)
